module.exports = __webpack_public_path__ + "assets/img/btn-view-20ac3c45.png";